import React, { useMemo } from "react";
import { TableListing } from "../../../../../../components/AppListing/TableListing";
import { formatPhoneNumber } from "../../../../../../utils/common_lib";
import ListIcon from "../../../../../../components/listIcon";
import Pagination from "../../../../../../components/pagination";

function LocationsListing({
  locations = [],
  locationsLoading = false,
  setSelectedLocation = () => {},
  pagination = null,
}) {

  const cols = useMemo(() => [
      {
        title: "Location Name",
        key: "name",
        colClass: "flex text-left",
      },
      {
        title: "Location ID",
        key: "id",
        colClass: "flex text-left",
      },
      {
        title: "Phone",
        key: "phone",
        colClass: "flex text-left",
        getData: (item) => item?.phone ? formatPhoneNumber(item?.phone) : <p className="px-6">-</p>,
      },
      {
        title: "City",
        key: "city",
        colClass: "flex text-left",
      },
      {
        title: "State",
        key: "state",
        colClass: "flex text-left",
      },
      {
        title: "Location Status",
        key: "status",
        colClass: "flex text-center",
        getData: (item) => `${item?.active ? "Active" : "Inactive"}`,
      },
      {
        title: "Actions",
        key: "actions",
        colClass: "flex text-center justify-center items-center",
        align: "center",
        skipColHtmlTooltip: true,
        getData: (item) => {
          return (
            <div className="flex gap-2 items-center justify-center h-[100%]">
              <ListIcon
                title="Care-co Settings"
                handler={() => setSelectedLocation({
                  showSettingsDialogue: true,
                  currentLocation: item,
                  settingsType: "care-co",
                })}
                type="care-co"
                disabled={false}
              />
            </div>
          );
        },
      },
    ], [setSelectedLocation]);

  return (
    <div className="px-3 mt-2 w-full h-[calc(100vh-130px)] overflow-y-auto shadow-md">
      <TableListing
        listData={locations || []}
        cols={cols || []}
        loading={locationsLoading || false}
      />
      {!locationsLoading && pagination?.totalRecords > pagination?.pageSize ? (
        <Pagination
          recordPerPage={pagination.pageSize}
          currentPage={pagination.currentPage}
          paginate={pagination.onPageChange}
          totalRecords={pagination.totalRecords}
        />
      ) : null}
    </div>
  );
}

export default LocationsListing;
